const lineColor = '#eee'
const textColor = '#999'

/** 实时价收益 / 日前价收益 两套配色 */
const SERIES_COLOR = {
  realtime: '#3A68FF',
  dayahead: '#F3C209',
}

function fmt(value, frac = 2) {
  if (value === null || value === undefined || value === '') return null
  const num = Number(value)
  return Number.isNaN(num) ? null : Number(num.toFixed(frac))
}

/**
 * 构造柱状 data。缺价的桶保持 null（ECharts 天然断点，不会画成 0），
 * 桶不完整的用 itemStyle.opacity 压暗，并把完整性信息挂在 item 上供 tooltip 取用。
 */
function buildBarData(rows, incomeKey, completeKey, missingKey, color) {
  return rows.map((row) => {
    const value = fmt(row[incomeKey])
    const complete = row[completeKey] !== false
    return {
      value,
      // 不完整的桶压暗，提示该值偏小
      itemStyle: complete ? undefined : { color, opacity: 0.4 },
      _missing: row[missingKey] || 0,
      _slotTotal: Number(row.slotTotal) || 0,
      _complete: complete,
    }
  })
}

/**
 * 现货收益图表 option
 * @param {Array} rows normalizeSpotRows 加工后的行
 * @param {'15min'|'hour'|'day'} granularity
 */
export function getSpotIncomeChartOption(rows = [], granularity = '15min') {
  const xData = rows.map((r) => r._label)

  return {
    grid: { left: '1%', right: '1%', top: '18%', bottom: rows.length > 48 ? '16%' : '10%', containLabel: true },
    legend: {
      show: true,
      top: 0,
      right: 0,
      icon: 'circle',
      itemWidth: 8,
      textStyle: { fontFamily: 'HarmonyOS Sans SC', color: textColor, fontSize: 12 },
      data: ['实时价收益', '日前价收益'],
    },
    xAxis: {
      type: 'category',
      data: xData,
      axisLabel: {
        color: textColor,
        fontSize: 10,
        // 15min 一天 96 格，交给 ECharts 自动抽稀，避免标签糊成一片
        interval: 'auto',
        hideOverlap: true,
        formatter: (val) => (granularity === 'day' ? val : String(val).slice(-5)),
      },
      axisTick: { show: false },
      axisLine: { show: false, lineStyle: { color: lineColor } },
    },
    yAxis: {
      type: 'value',
      name: '收益(元)',
      nameTextStyle: { fontFamily: 'HarmonyOS Sans SC', color: textColor, align: 'center' },
      // 收益可为负，不能设 min: 0
      splitLine: { lineStyle: { color: lineColor, type: 'dashed' } },
      axisLabel: { color: textColor, fontSize: 10 },
      axisLine: { show: false, lineStyle: { color: lineColor } },
      splitNumber: 6,
    },
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      className: 'chart-tooltip',
      backgroundColor: '#ffffff',
      borderColor: 'rgba(15, 23, 42, 0.06)',
      hideDelay: 0,
      enterable: false,
      formatter(params) {
        if (!params || !params.length) {
          return '<div class="chart-tooltip__items-container">暂无数据</div>'
        }
        const time = params[0].name
        let html = `<div class="chart-tooltip__time">时间: ${time}</div><div class="chart-tooltip__items-container">`
        let warn = ''
        params.forEach((p) => {
          const raw = p.data && typeof p.data === 'object' ? p.data : { value: p.data }
          const shown = raw.value === null || raw.value === undefined ? '缺价' : `${raw.value} 元`
          html += `
            <div class="chart-tooltip__series">
              <div class="chart-tooltip__point" style="background: ${p.color}"></div>
              <div class="chart-tooltip__series-name">${p.seriesName}: </div>
              <div class="chart-tooltip__value">${shown}</div>
            </div>`
          if (raw._complete === false && raw._missing > 0) {
            warn = `<div class="chart-tooltip__warn">⚠ 该时段 ${raw._missing}/${raw._slotTotal} 格缺价，汇总值偏小</div>`
          }
        })
        html += '</div>' + warn
        return html
      },
    },
    axisPointer: { link: { xAxisIndex: 'all' }, label: { backgroundColor: '#777' } },
    dataZoom: rows.length > 48
      ? [{ type: 'inside' }, { type: 'slider', height: 16, bottom: 4 }]
      : [{ type: 'inside' }],
    series: [
      {
        name: '实时价收益',
        type: 'bar',
        barMaxWidth: 10,
        itemStyle: { color: SERIES_COLOR.realtime, borderRadius: [3, 3, 0, 0] },
        data: buildBarData(rows, 'realtimeIncome', 'realtimeComplete', '_missingRt', SERIES_COLOR.realtime),
      },
      {
        name: '日前价收益',
        type: 'bar',
        barMaxWidth: 10,
        itemStyle: { color: SERIES_COLOR.dayahead, borderRadius: [3, 3, 0, 0] },
        data: buildBarData(rows, 'dayaheadIncome', 'dayaheadComplete', '_missingDa', SERIES_COLOR.dayahead),
      },
    ],
  }
}
